/**
 * Campaign lifecycle status (single source of truth).
 * - draft: editable, not shareable, not in "live" lists
 * - published: shareable via link/QR, in live lists, playable
 * - paused: not playable but resumable, link/QR still exists
 * - completed: campaign finished, data preserved, not playable
 */
export const CAMPAIGN_STATUS = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  PAUSED: 'paused',
  COMPLETED: 'completed',
};

/** Normalize legacy status to draft | published | paused | completed */
export function normalizeCampaignStatus(status) {
  if (!status) return CAMPAIGN_STATUS.DRAFT;
  const s = String(status).toLowerCase();
  if (s === 'published' || s === 'live' || s === 'active') return CAMPAIGN_STATUS.PUBLISHED;
  if (s === 'paused') return CAMPAIGN_STATUS.PAUSED;
  if (s === 'completed' || s === 'archived' || s === 'complete' || s === 'deleted') return CAMPAIGN_STATUS.COMPLETED;
  return CAMPAIGN_STATUS.DRAFT;
}

/** Whether the campaign is shareable (link/QR available in UI) */
export function isCampaignShareable(status) {
  const normalized = normalizeCampaignStatus(status);
  return normalized === CAMPAIGN_STATUS.PUBLISHED || normalized === CAMPAIGN_STATUS.PAUSED;
}

/** Whether the public play URL should serve the game */
export function isCampaignPlayable(status) {
  return normalizeCampaignStatus(status) === CAMPAIGN_STATUS.PUBLISHED;
}

/** Whether the campaign has been published at some point (for showing link/QR) */
export function isCampaignEverPublished(status) {
  const normalized = normalizeCampaignStatus(status);
  return normalized === CAMPAIGN_STATUS.PUBLISHED || 
         normalized === CAMPAIGN_STATUS.PAUSED || 
         normalized === CAMPAIGN_STATUS.COMPLETED;
}
